
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, mergeMap, catchError, switchMap, withLatestFrom, filter, distinctUntilChanged } from 'rxjs/operators';
import * as SearchActions from './actions';
import { AnnouncementService } from 'src/app/shared/services/announcement.service';
import { BannerService } from 'src/app/banner/shared/services/banner.service';
import { JobseekerService } from 'src/app/jobseeker/shared/services/jobseeker.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../state';
import { selectSelectedSkillMap } from './selectors';


@Injectable()
export class AnnouncementSearchEffects {

  loadFilterStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchActions.Actions.LoadFilterStats),
      mergeMap(() => this.announcementService.getFilterStats()
        .pipe(
          map(data => SearchActions.loadFilterStatsComplete({ payload: data })),
          catchError(err => of(SearchActions.loadFilterStatsFailed({ payload: err })))
        )
      )
    )
  );

  searchAnnouncements$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchActions.announcementSearch),
      mergeMap(action => this.announcementService.searchAnnouncements(action.payload)
        .pipe(
          map(response => SearchActions.searchComplete({ payload: response.data })),
          catchError(response => of(SearchActions.searchFail({ payload: response.error })))
        )
      )
    )
  );

  getSearchPageBannerList$ = createEffect(() => this.actions$.pipe(
    ofType(SearchActions.getSearchPageBannerList),
    mergeMap(action => this.bannerService.getBannerList(action.payload.targetId, action.payload.bannerHeadId)
    .pipe(
        map(response => SearchActions.getSearchPageBannerListSuccess({payload: response.data})),
        catchError(error => of(SearchActions.getSearchPageBannerListFailed({payload: error.error})))
    ))
));

  //skills
  loadSkillSuggestions$ = createEffect(() => this.actions$.pipe(
    ofType(SearchActions.loadSkillSuggestions),
    switchMap(action => this.jobseekerService.getSkillSuggestionsPublic(action.payload)
    .pipe(
        map(response => SearchActions.loadSkillSuggestionsSuccess({
          payload: { skillBaseType: action.payload.skillBaseType, result: response.data }
        })),
        catchError(response => of(SearchActions.loadSkillSuggestionsFail({payload: response.error})))
    ))
));

loadSelectedSkills$ = createEffect(() => this.actions$.pipe(
    ofType(SearchActions.loadSelectedSkills),
    map(action => action.payload.codes),
    filter(codes => codes.length > 0),
    mergeMap(codes => this.jobseekerService.getSkillListPublic({ codes: codes })
    .pipe(
        map(response => SearchActions.loadSelectedSkillsSuccess({ payload: response.data })),
        catchError(response => of(SearchActions.loadSelectedSkillsFail({payload: response.error})))
    ))
));

  constructor(
    private actions$: Actions,
    private announcementService: AnnouncementService,
    private bannerService: BannerService,
    private jobseekerService: JobseekerService,
    private store: Store<AppState>
  ) { }
}